import { CompanyCandidateListQueryVariables, Language } from "@generated/graphql";
import { FilterField } from "layout/TableConstructor/types";
import { InputType } from "components/generators/inputsGenerator";
import { generateOptions } from "helpers/index";
import { COMPANY_CANDIDATE_TYPE_TITLE, GRADE_OPTIONS, LANGUAGE_OPTIONS, TRIAL_STATUS_TITLE } from "constants/global";
import { IAutocompleteValue } from "components/inputs/Autocomplete/types";
import VALIDATION from "helpers/validation";
import typography from "constants/typography.constants";

export type CompanyCandidateFilter = NonNullable<CompanyCandidateListQueryVariables["filter"]>;

const filterConfig: FilterField<CompanyCandidateFilter>[] = [
  {
    name: "numericId",
    label: "ID кандидата",
    type: InputType.TEXT,
    inputType: "number",
  },
  {
    name: "fullName",
    label: "ФИО кандидата",
    type: InputType.TEXT,
  },
  {
    name: "createdAt",
    label: "Дата создания",
    type: InputType.DATE,
  },
  {
    name: "organization",
    label: "Организация",
    type: InputType.TEXT,
  },
  {
    name: "position",
    label: "Должность",
    type: InputType.TEXT,
  },
  {
    name: "type",
    label: "Тип",
    type: InputType.AUTOCOMPLETE,
    options: generateOptions(COMPANY_CANDIDATE_TYPE_TITLE),
    customFilter: (value) => value.id,
  },
  {
    name: "grade",
    label: "Грейд",
    type: InputType.AUTOCOMPLETE,
    options: GRADE_OPTIONS,
    customFilter: (value: IAutocompleteValue) => value.id,
  },
  {
    name: "email",
    label: "Email",
    type: InputType.TEXT,
    rules: VALIDATION.email,
  },
  {
    name: "telegramUsername",
    label: "Ник Telegram",
    type: InputType.TEXT,
    rules: VALIDATION.telegramUsername,
    additionalFilter: {
      isTelegram: true,
    },
  },
  {
    name: "login",
    label: "Логин",
    type: InputType.TEXT,
    additionalFilter: {
      isTelegram: false,
    },
  },
  {
    name: "phoneNumber",
    label: "Номер телефона",
    type: InputType.TEXT,
    rules: {
      maxLength: 11,
    },
  },
  {
    name: "language",
    label: "Язык",
    type: InputType.AUTOCOMPLETE,
    options: LANGUAGE_OPTIONS,
    customFilter: (value: { id: Language; displayName: string }) => value.id,
  },
  {
    name: "completedAt",
    label: "Дата последнего тестирования",
    type: InputType.DATE,
  },
  {
    name: "trialsCount",
    label: "Кол-во пройденных тестирований",
    type: InputType.TEXT,
    inputType: "number",
    rules: {
      min: {
        value: 0,
        message: typography.rules.min(0),
      },
    },
  },
  {
    name: "averageScore",
    label: "Средний результат",
    type: InputType.TEXT,
    inputType: "number",
    isRange: true,
    rules: {
      min: {
        value: 0,
        message: typography.rules.min(0),
      },
    },
  },
  {
    name: "lastTrialScore",
    label: "Последний результат",
    type: InputType.TEXT,
    inputType: "number",
    isRange: true,
  },
  {
    label: "Статус последнего тестирования",
    name: "lastTrialStatus",
    type: InputType.AUTOCOMPLETE,
    options: generateOptions(TRIAL_STATUS_TITLE),
    multiple: true,
    limitTags: 1,
    customFilter: (value: { id: string; displayName: string }[]) => value.map((v) => v.id),
  },
  {
    name: "lastTrialTime",
    label: "Время тестирования",
    type: InputType.TEXT,
    inputType: "number",
    isRange: true,
    customFilter: (value) => (value ? +value * 60 : undefined),
  },
];

export default filterConfig;
